import DefiTopOpportunity from "./DefiTopOpportunity";

export default DefiTopOpportunity;
